import * as type from '../actions/types';

const initialState = {
  data: [],
  error: '',
  pending: true,
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_BILLING_HISTORY_PENDING: {
      return {
        ...state,
        error: '',
        pending: true,
        success: false,
      };
    }

    case type.FETCH_BILLING_HISTORY_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        pending: false,
        success: true,
      };
    }

    case type.FETCH_BILLING_HISTORY_FAILURE: {
      return {
        ...state,
        error: action.payload,
        pending: false,
      };
    }

    default: {
      return state;
    }
  }
};
